(function () {
  'use strict';

  function openQuoteModal() {
    var modal = document.getElementById('quoteModal');
    if (!modal) return;
    modal.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeQuoteModal() {
    var modal = document.getElementById('quoteModal');
    if (!modal) return;
    modal.classList.remove('open');
    document.body.style.overflow = '';
  }

  function isDirectVideoFile(src) {
    return /\.(mp4|webm|ogv|ogg|mov|m4v)(\?|#|$)/i.test(src);
  }

  function openVideoModal(src, title) {
    var modal = document.getElementById('videoModal');
    var frame = modal ? modal.querySelector('.video-modal-frame') : null;
    var player = document.getElementById('videoModalPlayer');
    var nativeVideo = document.getElementById('videoModalNative');
    var titleEl = document.getElementById('videoModalTitle');
    if (!modal || !player) return;
    if (titleEl && title) titleEl.textContent = title;

    if (isDirectVideoFile(src)) {
      if (frame) frame.classList.add('is-native');
      player.removeAttribute('src');
      player.style.display = 'none';
      if (nativeVideo) {
        nativeVideo.style.display = 'block';
        nativeVideo.src = src;
        nativeVideo.play().catch(function () {});
      }
    } else {
      if (frame) frame.classList.remove('is-native');
      if (nativeVideo) {
        nativeVideo.pause();
        nativeVideo.removeAttribute('src');
        nativeVideo.style.display = 'none';
      }
      player.style.display = 'block';
      player.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'autoplay=1';
    }

    modal.removeAttribute('hidden');
    modal.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeVideoModal() {
    var modal = document.getElementById('videoModal');
    var player = document.getElementById('videoModalPlayer');
    var nativeVideo = document.getElementById('videoModalNative');
    if (!modal) return;
    modal.classList.remove('open');
    modal.setAttribute('hidden', '');
    document.body.style.overflow = '';
    if (player) player.src = '';
    if (nativeVideo) {
      nativeVideo.pause();
      nativeVideo.removeAttribute('src');
      nativeVideo.load();
    }
  }

  window.openQuoteModal = openQuoteModal;
  window.openVideoModal = openVideoModal;
  window.closeQuoteModal = closeQuoteModal;
  window.closeVideoModal = closeVideoModal;

  document.addEventListener('DOMContentLoaded', function () {
    var closeBtn = document.getElementById('quoteModalClose');
    var overlay = document.getElementById('quoteModal');
    var form = document.getElementById('quoteForm');
    var videoClose = document.getElementById('videoModalClose');
    var videoOverlay = document.getElementById('videoModal');

    if (closeBtn) closeBtn.addEventListener('click', closeQuoteModal);
    if (overlay) overlay.addEventListener('click', function (e) { if (e.target === overlay) closeQuoteModal(); });
    if (videoClose) videoClose.addEventListener('click', closeVideoModal);
    if (videoOverlay) videoOverlay.addEventListener('click', function (e) { if (e.target === videoOverlay) closeVideoModal(); });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeQuoteModal(); closeVideoModal(); }
    });

    if (form) {
      var successEl = document.getElementById('quoteFormSuccess');
      var submitBtn = form.querySelector('.quote-submit');

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var name = document.getElementById('qf-name').value.trim();
        var phone = document.getElementById('qf-phone').value.trim();
        var emailField = document.getElementById('qf-email');
        var email = emailField.value.trim();
        var product = document.getElementById('qf-product').value;
        var msg = document.getElementById('qf-msg').value.trim();
        if (!name || !phone) { alert('Please enter your name and phone number.'); return; }

        // Shopify's contact form needs a valid-looking email to send its notification;
        // fall back to a placeholder tied to the phone number when none is given.
        if (!email) emailField.value = phone.replace(/[^0-9]/g, '') + '@snifz-lead.local';

        var bodyLines = ['Phone: ' + phone];
        if (product) bodyLines.push('Product: ' + product);
        if (msg) bodyLines.push('Requirements: ' + msg);
        document.getElementById('qf-body').value = bodyLines.join('\n');

        if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Sending...'; }

        fetch(form.action, { method: 'POST', body: new FormData(form) })
          .catch(function () {})
          .then(function () {
            form.hidden = true;
            if (successEl) successEl.hidden = false;
            setTimeout(function () {
              closeQuoteModal();
              form.reset();
              form.hidden = false;
              if (successEl) successEl.hidden = true;
              if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = 'Send Request'; }
            }, 2500);
          });
      });
    }

    // Play buttons (video section)
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.play-btn');
      if (btn) {
        var src = btn.dataset.video;
        var title = btn.dataset.title;
        if (src) openVideoModal(src, title);
      }
    });
  });
})();
